// extracted by mini-css-extract-plugin
module.exports = {"sourceDetailDContainer":"sourceDetail_sourceDetailDContainer__2ooHI","gridContainer":"sourceDetail_gridContainer__1JTgM"};